import GroupThirdParty from './GroupThirdParty';

export default GroupThirdParty;
